module.exports = __webpack_public_path__ + "img/value4.2b9f535a.svg";